<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s0qgeA/tc-custom/9780547544588.jpg?1704278404975" alt="This image is the cover for the book Searching for Dragons, The Enchanted Forest Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Searching for Dragons, The Enchanted Forest Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p><b>As this young adult fantasy series continues, a princess must join forces with the king of the Enchanted Forest to find a missing dragon.</b></p><p>Cimorene, the princess who refuses to be proper, is back—but where is Kazul the dragon? That's what Cimorene is determined to find out! This updated edition features a new introduction by the author and fantastic new packaging.</p><p><b>“Wrede's tongue-in-cheek humor balances well with sweet adolescent discovery, and the result is another winning chapter in a delightful tale.”—<i>School Library Journal</i></b></p><p><b>“</b><b>Sensible princess Cimorene meets sensible king Mendanbar of the Enchanted Forest, and they sensibly decide to get married—but not before each mistakes the other for those greatest of twits, the pompous hero and the simpering princess…This sequel to revisionist-fabulist Wrede's <i>Dealing with Dragons </i>(1990) is as sprightly as the original…A refreshing romp.”—<i>Kirkus Reviews</i></b></p><p><b>“Dealing as it does with dragon-napping and magic-stealing, this sequel…puts a whimsical spin on familiar fairy-tale elements.”—<i>Publishers Weekly</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia C. Wrede
      </h2>
      
      <p class="authorDescription body article">For over twenty years, Patricia C. Wrede (b. 1953) has expanded the boundaries of young-adult fantasy writing. Her first novel, <i>Shadow Magic</i> (1982), introduced Lyra, a magical world in which she set four more novels. Her other series include the Enchanted Forest Chronicles; the Cecelia and Kate novels, co-written with Caroline Stevermer; the Mairelon books, which take place in Regency England; and the Old-West Frontier Magic series. Wrede lives and works in Minnesota.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7765f4df